"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sarezzano": {
    "10978fc0": [{
      "hkey": "2e7f5534",
      "slug": "sarezzano",
      "name": "Sarezzano",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-leardi": [{
      "hkey": "2e7f5534",
      "slug": "sarezzano",
      "name": "Sarezzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0bfcf988": [{
      "hkey": "efdc6300",
      "slug": "valle-sant-innocenzo",
      "name": "Valle Sant'Innocenzo",
      "primary": true,
      "skipSearch": false
    }],
    "valle-san-innocenzo": [{
      "hkey": "efdc6300",
      "slug": "valle-sant-innocenzo",
      "name": "Valle Sant'Innocenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;